module.exports = __webpack_public_path__ + "static/media/checked.95386a20.svg";